import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { InkDotFieldComponent } from '../ink-dot-field/ink-dot-field.component';

/** The shell's last route: the rail stays, the stage stays ink with no sheet, and there is one way home. */
@Component({
  host: { class: 'band-page' },
  imports: [TranslatePipe, InkDotFieldComponent],
  selector: 'inpla-not-found',
  templateUrl: './not-found.component.html',
  styleUrl: './not-found.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotFoundComponent {
  private readonly router: Router = inject(Router);

  /** Host and path, as the address bar shows them: "trustx.ai/agents". */
  public readonly attemptedPath = `${window.location.host}${this.router.url}`;

  public goHome(): void {
    void this.router.navigate(['/workspaces', 'home']);
  }
}
